<template>
  <b-dropdown v-if="loaded && activeWorkspaceId" ref="dropdown" right @show="onShow"  id="btn-dropdown">
<!--    <template #button-content>-->
<!--      Notifications <strong>{{notifyIsOn ? 'ON' : 'OFF'}}</strong>-->
<!--    </template>-->
    <template #button-content>
      <i class="img-icon img-icon-alarm-2" v-if="notifyIsOn"></i>
      <i class="img-icon img-icon-alarm-disable" v-else></i>
    </template>

    <b-dropdown-form>
      <div class="m-2">
        <div>
          <b-form-group label="Email:" class="p-2 mb-0" label-for="dropdown-form-email" @submit.stop.prevent>
            <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="onJobStart">When a job starts</b-form-checkbox>
            <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="onJobFinish">When a job ends</b-form-checkbox>
          </b-form-group>
        </div>
        <b-form-invalid-feedback :state="!errorMessage" class="text-center">
          {{errorMessage}}
        </b-form-invalid-feedback>
        <div class="d-flex p-2">
          <b-button variant="primary" size="sm" @click="applyClicked" class="ml-auto">Apply</b-button>
        </div>
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { UserUpdateSettingsRequest } from '#/protobuf/service_user_pb';
import { AccountUserSettings } from '#/protobuf/account_pb';
import { EventsToNotifyOn } from '#/protobuf/enums_pb';
import { isNotifyOnJobFinish, isNotifyOnJobStart } from '#/models/notifications/notifications';

export default {
  data() {
    return {
      loaded: false,
      onJobStart: false,
      onJobFinish: false,
      errorMessage: undefined,
    };
  },
  created() {
    return this.onShow(); // do an initial load for the main on/off label
  },
  computed: {
    ...mapGetters([
      'activeWorkspaceId',
    ]),
    notifyIsOn() {
      return this.onJobStart || this.onJobFinish;
    },
  },
  methods: {
    onShow() {
      // there is already a built in delay to how quickly the user can open / close / reopen this dropdown
      // so no need to throttle here.
      console.info('loading user notification settings');
      return this.$store.dispatch('user/loadWorkspaceUserSettings').then((result) => {
        console.info('loaded user settings', result);
        const workspaceId = this.$store.getters.activeWorkspaceId;
        const settings = this.$store.getters['user/settingsForWorkspaceId'](workspaceId);
        console.info('workspace settings', workspaceId, settings);
        this.onJobStart = isNotifyOnJobStart(settings.notifyEvents);
        this.onJobFinish = isNotifyOnJobFinish(settings.notifyEvents);
      }).catch((error) => {
        console.warn('error loading user settings', error);
        this.errorMessage = 'Error loading settings';
      }).finally(() => {
        this.loaded = true;
      });
    },
    applyClicked() {
      const request = new UserUpdateSettingsRequest();
      const settings = new AccountUserSettings();
      let notifyEvents = EventsToNotifyOn.EVENT_NOTIFICATION_NONE;
      if (this.onJobStart) {
        // turn on the job init bit if the user has it selected
        // eslint-disable-next-line no-bitwise
        notifyEvents |= EventsToNotifyOn.EVENT_NOTIFICATION_JOB_INIT;
      }

      if (this.onJobFinish) {
        // turn on the job finalize bit if the user has it selected
        // eslint-disable-next-line no-bitwise
        notifyEvents |= EventsToNotifyOn.EVENT_NOTIFICATION_JOB_FINALIZE;
      }
      settings.setNotifyEvents(notifyEvents);
      settings.setNotifyByEmail(true);
      settings.setNotifyOnlyPersonal(false);

      // this commented out code applies the current project as a scope for the notifications
      // for now - we are just setting notifications as workspace wide (all projects in a workspace).
      // const pid = this.$route.query.project;
      // if (pid) {
      //   settings.setProjectId(pid);
      // }

      request.setSettings(settings);

      this.$store.dispatch('user/updateUserAccountSettings', request).then((result) => {
        console.info('successfully set notification settings', result);
        this.$refs.dropdown.hide(true);
      }).catch((error) => {
        console.warn('caught error applying user settings', error);
        this.errorMessage = 'An error occurred';
      });
    },
  },
};
</script>

<style>
.b-dropdown-form {
    padding: 0.25rem 0.5rem;
}
#btn-dropdown {
  padding-top: 10px;
}

#btn-dropdown .btn {
  padding: 4px !important;
}
.navbar-top .nav-item .dropdown-menu {
  left: auto;
  right: calc(100% - 36px);
  min-width: 200px;
}
</style>
